import { Grid, TextField } from "@material-ui/core"
import { useSelector, useDispatch } from "react-redux"
import { ToastMessage } from "../../../../../global/ToastMessage"
import { addAdultosAction, addItemsAction, addMenoresAction, addInfantesAction, addIndividualAction, addMetodoPagoAction } from "../../../../../ducks/cotizadorPaqueteDuck"
const FieldAdultos = () => {
    const { cantidadAdultos, clavePaquete, listaItems, fechaSalida } = useSelector(store => store.cotizadorPaquete)
    const dispatch = useDispatch()
    const handleChange = (event) => {
        const newCantidadPasajeros = event.target.value
        if (Number(newCantidadPasajeros) < 0) {
            ToastMessage.fire({
                icon: "info",
                title: "La cantidad de pasajeros debe ser mayor o igaul a 1",
            })
            return
        }
        if (Number(newCantidadPasajeros) === 0) {
            dispatch(addMetodoPagoAction({ metodoPago: "0" }))
        }
        let arrayItems = [...listaItems]
        dispatch(addInfantesAction({ cantidad: 0 }))
        dispatch(addMenoresAction({ cantidad: 0 }))
        const arrayItemsFilt = arrayItems.filter(item => {
            return (item.type !== "PLAZA" && item.type !== "PLAZAM" && item.type !== "PLAZAI")
        })
        dispatch(addIndividualAction({ individual: "0" }))
        dispatch(addItemsAction({ listaItem: arrayItemsFilt }))
        dispatch(addAdultosAction({ cantidad: newCantidadPasajeros }))
    }
    return (
        <Grid container>
            <Grid item xs={12}>
                <TextField
                    disabled={clavePaquete === "0" || fechaSalida === "0,0,0"}
                    value={cantidadAdultos}
                    style={{ width: "97%", margin: "0.5rem 0" }}
                    id={`outlined-number-Adultos`}
                    label="Adultos"
                    name="adultos"
                    onChange={handleChange}
                    type="number"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    InputProps={{
                        inputProps: { min: 0, max: 40 }
                    }}
                    variant="outlined"
                />
            </Grid>
        </Grid>
    )
}
export default FieldAdultos